module.exports = __webpack_public_path__ + "media/images/icons/google-g-672480cbc7f0ef3198d34a5a44b67a67.svg";